<template>
  <div
    class="d-flex flex-column mt-sm-5 pt-sm-5 mt-xxs-3 pt-xxs-3 px-sm-5 px-xxs-2 mx-sm-5 mx-xxs-3 justify-content-center align-items-center"
  >
    <b-link
      :to="{name:'profile'}"
      class="text-dark align-self-start align-content-center my-3 mx-5 lead"
    >
      <img height="30" class="bidi-icon" src="@/assets/icons/back.svg">
      {{ $t('common.back') }}
    </b-link>
    <UserProfileNewUserSubscriptions
      :subscription-plans="SubscriptionPlans"
      @SelectPlan="SelectPlan"
    />
  </div>
</template>

<script>
import UserProfileNewUserSubscriptions from '@/components/UserProfileNewUserSubscriptions.vue'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'BuySubscription',
  components: {
    UserProfileNewUserSubscriptions
  },
  computed: {
    ...mapGetters({
      SubscriptionPlans: 'order/subscriptionPlans'
    })
  },
  data () {
    return {
      SubscriptionPlansData: [
        // {
        //   Icon: "/img/ps-top.svg",
        //   Title: "اشتراک سالانه",
        //   Price: 180000,
        //   Description: "",
        //   Discount: 20,
        //   Accent: "success-light",
        //   TextAccent: "success",
        //   SubscriptionTime: "دوازده ماه",
        //   Unit: "تومان",
        //   DiscountedPrice: 180000 - (180000 * 20) / 100,
        //   Type: "Yearly"
        // },
        // {
        //   Icon: "/img/ps-left.svg",
        //   Title: "اشتراک ماهیانه",
        //   Price: 15000,
        //   Description: "",
        //   Discount: 10,
        //   Accent: "secondary-light",
        //   TextAccent: "secondary",
        //   SubscriptionTime: "یک ماه",
        //   Unit: "تومان",
        //   DiscountedPrice: 15000 - (15000 * 10) / 100,
        //   Type: "Monthly"
        // },
        // {
        //   Icon: "/img/ps-right.svg",
        //   Title: "اشتراک هفتگی",
        //   Price: 500,
        //   Description: "",
        //   Discount: "",
        //   Accent: "warning-light",
        //   TextAccent: "warning",
        //   SubscriptionTime: "یک هفته",
        //   Unit: "تومان",
        //   Type: "Weekly"
        // },
        // {
        //   Icon: "/img/ps-bottom.svg",
        //   Title: "اشتراک روزانه",
        //   Price: 500,
        //   Description:
        //     "هزینه این نوع اشتراک را با شارژ تلفن همراه پرداخت خواهید کرد. تا هنگامیکه اشتراک را لغو نکنید، مشترک خواهید ماند",
        //   Discount: "",
        //   Accent: "primary-light",
        //   TextAccent: "primary",
        //   SubscriptionTime: "",
        //   Unit: "تومان",
        //   Type: "Daily"
        // }
      ]
    }
  },

  methods: {
    ...mapActions({
      setSubscriptionPlan: 'order/setSubscriptionPlan',
      setSubscriptionPlans: 'order/setSubscriptionPlans'
    }),
    SelectPlan (selectedPlan) {
      // let payLoad = {
      //   Icon: selectedModel.Icon,
      //   Title: selectedModel.Title,
      //   Price: selectedModel.Price,
      //   Description: selectedModel.Description,
      //   Discount: selectedModel.Discount,
      //   Accent: selectedModel.Accent,
      //   TextAccent: selectedModel.TextAccent,
      //   Unit: selectedModel.Unit,
      //   DiscountedPrice: selectedModel.DiscountedPrice,
      //   SubscriptionTime: selectedModel.SubscriptionTime
      // };
      this.setSubscriptionPlan(selectedPlan)
      this.$router.push({ path: 'buysubscriptionfactor' })
    }
  },
  mounted () {
    // this.SelectPlan(this.subscriptionPlan);
    this.setSubscriptionPlans(this.SubscriptionPlansData)
  }
}
</script>
